import functions from '@mindthegapstudio/stpancras-storybook-app/src/plugins/functions'

const go = (destinationUrl) => {
  window.location.href = destinationUrl
}
const install = (Vue) => {
  Vue.prototype.$func = {
    ...functions,
    go,
  }
}

export default {
  install,
}
